import { useMandatorContext } from "@rentablo/theming";

const defaultStyles = {
  fontWeight: {
    yAxis: "500",
    xAxis: "500",
    navigator: "500",
  },
};

const kpmgStyles = {
  fontWeight: {
    yAxis: "600",
    xAxis: "600",
    navigator: "500",
  },
};

export const useGetMandatorStyles = () => {
  const { mandatorSlug } = useMandatorContext();
  switch (mandatorSlug) {
    case "kpmg-germany":
      return kpmgStyles;
    default:
      return defaultStyles;
  }
};
